import { render, staticRenderFns } from "./AnnouncementInfos.vue?vue&type=template&id=57be1410&scoped=true&"
import script from "./AnnouncementInfos.vue?vue&type=script&lang=js&"
export * from "./AnnouncementInfos.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementInfos.vue?vue&type=style&index=0&id=57be1410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57be1410",
  null
  
)

export default component.exports